module.exports = new __parcel__URL__("khotynenko_x2.42dbcf96.webp").toString();